import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AbolitionReason,
  formClassFacility,
  FormKbn,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import {
  httpAPI_FAC009,
  httpAPI_FAC035,
  httpIAPI_CON031,
  httpIAPI_CON030,
} from "./api/request";
import { contextText, fakeTableList, schema, stepperData } from "./parts";
import { IAPI_FAC009_Request } from "../../type/apiType";
import _ from "lodash";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * SCRC050122 廃止・休止・経営移管施設情報登録
 * @return SCRC050122 廃止・休止・経営移管施設情報登録
 */
const SCRC050122 = () => {
  const navigate = useNavigate();

  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const { state, setState } = useContext(GlobalContext);

  const [fakeTableListInState, setStateFakeTableList] = useState<any>([]);
  const [selectedReason, setSelectedReason] = useState("");
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [requestData, setRequestData] = useState<IAPI_FAC009_Request>();
  const [stateSchema, setStateSchema] = useState<any>(schema.common);
  const [staffNoInfoList, setStaffNoInfoList] = useState<any>([]);
  const [openWarning, setOpenWarning] = useState(false);

  const context = businessState?.job_18;
  const userType = state?.authInfo?.userType;
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isUserTypeKiko
    ? businessState?.common?.contractorNo
    : state?.authInfo?.contractorNo;
  const stateFakeTableListRef = useRef(_.cloneDeep(fakeTableList));
  const stateFakeTableList = stateFakeTableListRef.current;
  const location = useLocation();
  const { facilityNo, obosoleteStatus } = location.state || {};
  const allDisabled = obosoleteStatus === "登録完了";

  // 初期表示
  useEffect(() => {
    let resArr = stateFakeTableList;
    let reasonList = resArr.find((item) => item.keyword === "reason")!;
    reasonList.onGetValue = setSelectedReason;

    setStateFakeTableList([...resArr]);

    // 持回情報.申請idがある場合
    context?.applyId && handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInit = async () => {
    try {
      // 共済契約対象施設等一部廃止届参照API 呼び出し
      const res = await httpAPI_FAC035({
        applyId: context?.applyId,
        facilityNo,
      });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList;

        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;
          if (targetObj) {
            targetObj.setDefaultValue = res[i as keyof typeof res];
            allDisabled && (targetObj.disabled = true);
          }
        }

        res.reason && setSelectedReason(res.reason);
        // 廃止・休止が確認できる書類の添付
        let fileUpload = resArr.find((item) => item.keyword === "fileUpload")!;
        let settingFile = res.formList?.find(
          (item) =>
            item.formClass ===
            formClassFacility["廃止・休止が確認できる書類の添付"]
        )!;
        settingFile &&
          (fileUpload.setDefaultValue = [
            {
              formName: settingFile?.formName ?? "",
              fileBase64: settingFile?.fileBase64 ?? "",
            },
          ]);
        allDisabled && (fileUpload.disabled = true);

        setStateFakeTableList([...resArr]);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  useEffect(() => {
    let resArr = stateFakeTableList;
    let aContractorNo = resArr.find(
      (item) => item.keyword === "aContractorNo"
    )!;
    let aCorpname = resArr.find((item) => item.keyword === "aCorpname")!;
    switch (selectedReason) {
      case AbolitionReason["ア　廃止"]:
        aContractorNo.setDefaultValue = "";
        aCorpname.setDefaultValue = "";
        aContractorNo.showLine = false;
        aCorpname.showLine = false;
        setStateSchema(schema.common);
        break;
      case AbolitionReason["イ　休止"]:
        aContractorNo.setDefaultValue = "";
        aCorpname.setDefaultValue = "";
        aContractorNo.showLine = false;
        aCorpname.showLine = false;
        setStateSchema(schema.common);
        break;
      case AbolitionReason["ウ　経営移管"]:
        aContractorNo.showLine = true;
        aCorpname.showLine = true;
        setStateSchema({
          ...schema.common,
          ...schema.contractorNo,
        });
        break;
    }
    setStateFakeTableList([...resArr]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedReason]);

  const onCheckAndSubmit = (data: any) => {
    const today = new Date();
    const nextYearDate = new Date(
      today.setFullYear(today.getFullYear() + 1)
    ).setHours(0, 0, 0, 0);
    const obsoleteDate = new Date(data.obsoleteDate).setHours(0, 0, 0, 0);

    //業務チェック
    if (obsoleteDate >= nextYearDate) {
      //入出力項目.廃止・休止・経営移管年月日 ≧ システム日付 + 1年
      setOpenWarning(true);
    } else {
      setOpen(true);
    }
    setRequestData({
      applyId: context?.applyId,
      contractorNo,
      facilityNo: location.state.facilityNo,
      reason: data.reason,
      obsoleteDate: data.obsoleteDate,
      formList: [
        {
          serialNo: 1,
          facilityNo: "",
          staffNo: "",
          formKbn: FormKbn["施設書類"],
          formClass: formClassFacility["廃止・休止が確認できる書類の添付"],
          fileName: data.fileUpload[0].formName,
          fileBase64: data.fileUpload[0].fileBase64,
        },
      ],
      aCorpname: data.aCorpname,
      aContractorNo: data.aContractorNo,
      screenId: "SCRC050122",
    });
  };

  const callAPI_FAC009 = async (shouldCallIAPI_CON030: boolean) => {
    try {
      //共済契約対象施設等一部廃止届更新API呼び出し
      const res = (await httpAPI_FAC009({
        ...requestData,
      })) as { [key: string]: any };
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        let applyId = res.applyId ?? context?.applyId;
        setBusinessState({
          ...businessState,
          job_18: {
            ...businessState.job_18,
            applyId: applyId,
          },
        });
        if (shouldCallIAPI_CON030) {
          callIAPI_CON030();
        } else {
          // 遷移元画面に戻る
          navigate("/SCRC050121");
        }
      } else {
        setOpen1(false);
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
      return;
    }
  };

  const callIAPI_CON030 = async () => {
    try {
      const res = await httpIAPI_CON030({
        contractorNo,
        staffNoInfoList,
        businessType: businessState.common?.businessType,
        applyId: context?.applyId ?? null,
      });
      if (res.resultCd === "I0000") {
        // 遷移元画面に戻る
        navigate("/SCRC050121");
      } else {
        setOpen1(false);
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleOk = async () => {
    setState({
      ...state,
      errorMsgId: "",
    });
    setOpen(false);

    try {
      // 日々更新法人職員系の退職年月日削除職員確認APIを呼び出す
      const resApi = await httpIAPI_CON031({
        contractorNo,
        businessType: businessState.common?.businessType,
        applyId: context?.applyId ?? null,
        facilityObsoleteList: [
          {
            facilityNo: location.state.facilityNo,
            obsoleteDate: requestData?.obsoleteDate,
          },
        ],
      });

      if (resApi.resultCd === "I0000") {
        if (!!resApi.staffNoInfoList?.length) {
          setStaffNoInfoList(resApi.staffNoInfoList);
          setOpen1(true);
        } else {
          //共済契約対象施設等一部廃止届更新API呼び出し
          callAPI_FAC009(false);
        }
      } else {
        setState({
          ...state,
          errorMsgId: resApi.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  const handleOk1 = () => {
    callAPI_FAC009(true);
  };

  const handleOpenSubmitModal = () => {
    setOpenWarning(false);
    setOpen(true);
  };

  return (
    <Box data-testid="SCRC050122PageForTest">
      <TkStepper steps={stepperData} activeStep={1}></TkStepper>
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC050122_01}</TkInfoManual>
      {isUserTypeKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={`${businessState.common?.contractorNo ?? ""}:${
            businessState.common?.contractorName ?? ""
          }`}
        />
      )}

      <TkFakeTable
        list={fakeTableListInState}
        onCheckAndSubmit={(data) => {
          onCheckAndSubmit(data);
        }}
        ruleSchema={stateSchema}
        buttonGroup={<TkBackButton />}
        submitButtonGroup={[
          {
            submitButtonText: "登録",
            submitButtonDisabled: allDisabled,
          },
        ]}
      />

      <TkMessageDialog
        data-testid="dialog"
        open={open}
        onOky={() => handleOk()}
        onCancel={() => setOpen(false)}
        title="確認（情報を登録します）"
        contextText="　入力した内容で登録を行いますが、問題ないでしょうか。"
        okText="はい"
        cancelText="いいえ"
      />

      <TkMessageDialog
        data-testid="dialog"
        open={open1}
        onOky={() => handleOk1()}
        onCancel={() => setOpen1(false)}
        title="確認（退職(予定)年月日・異動情報(配置換え)が削除されます）"
        children={<TkInfoManual rule={"<"}>{contextText}</TkInfoManual>}
        okText="はい"
        cancelText="いいえ"
      />
      <TkMessageDialog
        open={openWarning}
        onOky={handleOpenSubmitModal}
        onCancel={() => setOpenWarning(false)}
        onClose={() => setOpenWarning(false)}
        title="警告"
        contextText={TkPropertyMessageGet("TKMSG_SCR0024W")}
        okText="確認"
        cancelText="戻る"
      />
    </Box>
  );
};

export default SCRC050122;
